
export function getGeneralData(generalDataRepository) {
  return generalDataRepository.get();
}